import React from 'react';

const CommissionStick = () => {
  const reasons = [
    {
      icon: "fa-sync-alt",
      title: "94% Retention",
      color1: "#6A00FF",
      color2: "#00D4FF",
      desc: "Once brands start using Hector, they stay (because it works)",
    },
    {
      icon: "fa-ban",
      title: "No Churn Clawbacks",
      color1: "#FF0095",
      color2: "#5718E7",
      desc: "Even if someone cancels, you keep the commission you earned",
    },
    {
      icon: "fa-money-check-alt",
      title: "Reliable Payouts",
      color1: "#00FFA3",
      color2: "#00D1FF",
      desc: "We’ve never missed a payment",
    },
  ];

  return (
    <section
      id="commission-stick"
      className="relative py-20 md:py-28 overflow-hidden"
      style={{
        background: "linear-gradient(135deg, #F4E8FF 0%, #F8F5FF 100%)",
      }}
    >
      {/* Floating ribbons background */}
      <div className="absolute inset-0 opacity-40 pointer-events-none">
        <div className="absolute -top-20 left-0 w-[200%] md:w-[140%] h-64 md:h-96 bg-gradient-to-r from-[#CC2EF477] to-[#3E2EF477] blur-[90px] md:blur-[120px] rotate-[8deg]"></div>
        <div className="absolute top-32 right-0 w-[200%] md:w-[160%] h-64 md:h-96 bg-gradient-to-l from-[#00D4FF55] to-[#FF00AE55] blur-[90px] md:blur-[120px] rotate-[-12deg]"></div>
      </div>

      {/* MAIN CONTENT */}
      <div className="relative z-10 container mx-auto px-2 md:px-6">

        {/* TITLE BUBBLE */}
        <div className="mx-auto mb-16 md:mb-20 text-center px-2">
          <div className="inline-block bg-white/40 backdrop-blur-xl px-6 md:px-10 py-4 md:py-6 rounded-3xl shadow-lg">
            <h2 className="text-[25px] md:text-4xl lg:text-6xl font-extrabold text-hector-black tracking-tight leading-snug">
              Why These Commissions
              <span className="bg-gradient-to-r from-[#CC2EF4] to-[#3E2EF4] bg-clip-text text-transparent">
                {" "}Actually Stick
              </span>
            </h2>
          </div>
        </div>

        {/* FLOATING ORB ICONS */}
        <div className="relative flex justify-center mb-16 md:mb-12">

          {/* MOBILE → STACKED VERTICAL */}
          <div className="flex flex-col gap-12 md:hidden items-center">
            {reasons.map((r, i) => (
              <div key={i} className="flex flex-col items-center text-center">
                <div
                  className="w-20 h-20 rounded-full shadow-2xl flex items-center justify-center text-white"
                  style={{
                    background: `linear-gradient(135deg, ${r.color1}, ${r.color2})`,
                  }}
                >
                  <i className={`fas ${r.icon} text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-hector-black mt-4">{r.title}</h3>
                <p className="text-gray-700 max-w-xs mt-2 leading-relaxed">
                  {r.desc}
                </p>
              </div>
            ))}
          </div>

          {/* DESKTOP FLOATING POSITIONS (unchanged) */}
          <div className="hidden md:block relative w-full max-w-4xl h-72">

            {reasons.map((r, i) => {
              const positions = [
                "top-0 left-0",
                "top-0 -right-10",
                "top-20 left-[40%] -translate-x-1/2",
              ];

              const float = [
                "animate-[float_4s_ease-in-out_infinite]",
                "animate-[float_5s_ease-in-out_infinite]",
                "animate-[float_6s_ease-in-out_infinite]",
              ];

              return (
                <div
                  key={i}
                  className={`absolute ${positions[i]} ${float[i]} flex flex-col items-center text-center`}
                >
                  <div
                    className="w-24 h-24 rounded-full shadow-2xl flex items-center justify-center text-white"
                    style={{
                      background: `linear-gradient(135deg, ${r.color1}, ${r.color2})`,
                    }}
                  >
                    <i className={`fas ${r.icon} text-3xl`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-hector-black mt-4">{r.title}</h3>
                  <p className="text-gray-700 max-w-xs mt-2 leading-relaxed">{r.desc}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* CTA BUTTON */}
        <div className="text-center">
   <a 
  href="https://hector.partnerstack.com/" 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block"
>
  <button
    className="relative px-8 md:px-12 py-4 md:py-5 rounded-full font-bold text-base md:text-xl text-white shadow-2xl hover:shadow-[0_0_40px_#CC2EF4] transition-all duration-300 transform hover:-translate-y-2 overflow-hidden w-auto inline-block"
    style={{
      background: "linear-gradient(90deg, #CC2EF4 0%, #3E2EF4 100%)",
    }}
  >
    <span className="absolute inset-0 bg-white/10 translate-x-[-200%] hover:translate-x-[200%] transition-transform duration-700"></span>
    GET YOUR AFFILIATE LINK IN 5 MINUTES
  </button>
</a>


          <p className="text-sm text-gray-700 mt-4 px-4">
            <span className="font-bold text-hector-black">Build passive income from your network</span> Start in 5 minutes.
          </p>
        </div>

      </div>

      {/* FLOAT KEYFRAME */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-15px); }
        }
      `}</style>
    </section>
  );
};

export default CommissionStick;
